import React from 'react';
import {Section} from '../../../admin/artisticobjects/types/Section';
import {ArtisticObjectSections} from '../../../admin/core/types/DictionaryItem';
import {DEFAULT_LANGUAGE} from '../../i18n/config';

interface DetailsInscriptionsSignaturesProps {
  sections?: Section[];
  currentLanguage?: string;
}

const findSectionByLanguage = (
  sections: Section[],
  alias: ArtisticObjectSections,
  currentLanguage: string
): Section | undefined => {
  const matchingSections = sections.filter(s => s.type.alias === alias);
  if (matchingSections.length === 0) return undefined;

  const currentLangSection = matchingSections.find(s => s.language === currentLanguage);
  const defaultLangSection = matchingSections.find(s => s.language === DEFAULT_LANGUAGE);
  return currentLangSection || defaultLangSection || matchingSections[0];
};

const DetailsInscriptionsSignatures: React.FC<DetailsInscriptionsSignaturesProps> = ({
                                                                                       sections = [],
                                                                                       currentLanguage = DEFAULT_LANGUAGE
                                                                                     }) => {
  const inscriptions = findSectionByLanguage(sections, ArtisticObjectSections.ANSK, currentLanguage);
  const signatures = findSectionByLanguage(sections, ArtisticObjectSections.SNTR, currentLanguage);

  if (!inscriptions && !signatures) {
    return null;
  }

  const renderSection = (section: Section) => {
    return (
      <div className="space-y-2">
        <div
          className="text-sm text-stone-700"
          dangerouslySetInnerHTML={{__html: section.content}}
        />
      </div>
    );
  };

  return (
    <div id="inscriptions-signatures-card" className="bg-white shadow-sm p-6">
      {inscriptions && (
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-stone-900 mb-3">
            {inscriptions.type.value}
          </h3>
          {renderSection(inscriptions)}
        </div>
      )}

      {signatures && (
        <div className={inscriptions ? '' : ''}>
          <h3 className="text-lg font-semibold text-stone-900 mb-3">
            {signatures.type.value}
          </h3>
          {renderSection(signatures)}
        </div>
      )}
    </div>
  );
};

export default DetailsInscriptionsSignatures;

